export enum RuntimeEnvironment {
    DEVELOPMENT = 'development',
    PREVIEW = 'preview',
    PRODUCTION = 'production',
}
